/**
 * Small "vs" pill placed between two logos.
 * @returns the chip
 */
export default function VsChip() {
  return (
    <span className="shrink-0 rounded-full border border-landing-primary bg-white px-2.5 py-1 text-tag-sm text-landing-secondary">
      vs
    </span>
  );
}
